import type { AreaCatalog } from '../area';
import type { kit as en } from '../en/kit';

export const kit = {
  'kit.chipInput.placeholder': 'Wert hinzufügen…',
  'kit.chipInput.describe': 'Was bedeutet „{value}“? (optional)',
  'kit.chipInput.addDescription': 'Beschreibung hinzufügen',
  'kit.chipInput.remove': '{value} entfernen',
  'kit.chipInput.descriptionFor': 'Beschreibung für {value}',
  'kit.dialog.close': 'Schließen',
  'kit.helpTip.label': 'Was ist das?',
  'kit.menu.label': 'Menü',
  'kit.menu.back': 'Zurück',
  'kit.multiSelect.none': 'Keine',
  'kit.select.placeholder': 'Auswählen…',
  'kit.skeleton.loading': 'Wird geladen',
  'kit.relativeTime.now': 'jetzt',
  'kit.relativeTime.minutes': '{count} Min.',
  'kit.relativeTime.hours': '{count} Std.',
  'kit.relativeTime.days': '{count} T.',
  'kit.relativeTime.weeks': '{count} Wo.',
  'kit.dnd.instructions':
    'Um einen Eintrag aufzunehmen, drück die Leertaste oder Enter. Verschieb ihn mit den Pfeiltasten. Drück die Leertaste oder Enter noch einmal, um ihn an der neuen Stelle abzulegen, oder Escape zum Abbrechen.',
  'kit.dnd.entry': 'ein Eintrag',
  'kit.dnd.pickedUp': '{name} aufgenommen.',
  'kit.dnd.over': '{name} ist über {target}.',
  'kit.dnd.moved': '{name} verschoben.',
  'kit.dnd.droppedOn': '{name} auf {target} abgelegt.',
  'kit.dnd.dropped': '{name} abgelegt.',
  'kit.dnd.cancelled':
    'Verschieben von {name} abgebrochen; der Eintrag ist wieder an seinem Platz.',
  'kit.proseEditor.strip': 'Formatierung',
  'kit.proseEditor.bold': 'Fett',
  'kit.proseEditor.italic': 'Kursiv',
  'kit.proseEditor.strike': 'Durchgestrichen',
  'kit.proseEditor.code': 'Code',
  'kit.proseEditor.bulletList': 'Aufzählung',
  'kit.proseEditor.numberedList': 'Nummerierte Liste',
  'kit.proseEditor.heading': 'Überschrift',
  'kit.proseEditor.quote': 'Zitat',
  'kit.proseEditor.link': 'Link',
  'kit.proseEditor.person': 'Person nennen',
  'kit.proseEditor.item': 'Aufgabe nennen',
  'kit.proseEditor.people': 'Personen',
  'kit.proseEditor.items': 'Aufgaben',
  'kit.proseEditor.findPerson': 'Person suchen',
  'kit.proseEditor.findItem': 'Aufgabe suchen',
  'kit.proseEditor.searching': 'Wird gesucht…',
  'kit.proseEditor.noPerson': 'Niemand passt.',
  'kit.proseEditor.noItem': 'Keine Aufgabe passt.',
  'kit.proseEditor.cannotSee': 'Kann diese Aufgabe nicht sehen',
  'kit.proseEditor.linkAddress': 'Linkadresse',
  'kit.proseEditor.linkPlaceholder': 'https://…',
  'kit.proseEditor.linkApply': 'Übernehmen',
  'kit.proseEditor.linkRemove': 'Link entfernen',
  'kit.proseEditor.linkInvalid': 'Ein Link kann nur eine Webadresse (http oder https) sein.',
  'kit.proseEditor.filesRefused': 'Bilder und Dateien werden hier noch nicht unterstützt.',
} as const satisfies AreaCatalog<typeof en>;
